// extracted by mini-css-extract-plugin
module.exports = {"commit-type":"commit-type__3esLz","buttons":"buttons__1jhXO"};